<template>
<v-container px-md-10 fluid>

    <v-card
    class="mx-auto"
    max-width="100%"
  >
    <v-img
      class="align-center"
      height="200px"
      src="/Images/drone-pool-shot.jpg"
    >
      <div class="white--text align-top text-left pl-3" v-if="$vuetify.breakpoint.mdAndUp">
      <h1 ><i>Sky Farm Nudist Resort</i></h1>
      <p  ><i >Basking Ridge, New Jersey</i></p>
      <p class="green--text darken-4">.</p>
      </div>
      <div class="white--text align-end text-right pr-3" v-if="$vuetify.breakpoint.mdAndUp">
      <h3><i>There’s Nothing Else Like It Under The Sun</i></h3>
      </div>
    </v-img>
  </v-card>


  <v-row class="text-center" v-if="$vuetify.breakpoint.smAndDown">
    <v-col class="mb-2 " cols="12">
      <h1 class="indigo--text"><i>Sky Farm Nudist Resort</I></h1>
      <h3>In Basking Ridge, NJ</h3><br>
      <h3>There’s Nothing Else Like It Under The Sun</h3>
    </v-col>
  </v-row>


  <v-row class="text-left mt-4">
    <v-col class="mb-2" md="8">      
    <h3 class="mb-3 indigo--text">
    Sky Farm is a members only, family oriented, nudist resort located on a 36-acre slice of heaven in beautiful Basking Ridge, NJ.  
    <!-- Here, we invite you to enjoy friends, food, drink, activities, and nature, naturally! -->
    </h3>      
      <ul>
        <li
           v-for="(fact, i) in facts"
           :key=i
           v-html="fact">
        </li>
      </ul>
      <br>


          <v-row class="text-center">
            <v-col class="mb-2" md="6">
              <Events ewheight="355" 
                      v-bind:ewdesc="false" 
                      v-bind:ewtime="true" 
              />

              <Love/>
              <National/>
            </v-col>

            <v-col class="mb-2" md="6">
              <NkdAge/>
              <Video/>
            </v-col>

          </v-row>
          
      </v-col>
      <v-col md="4">
        <Visit/>
        <WhatsNude/>
      </v-col>

    </v-row>

  </v-container>
</template>

<script>
import Events    from '../widgets/Events.vue';
import Visit     from './page-parts/how-to-visit.vue';
import WhatsNude from './page-parts/whats-nude.vue';
import National  from './page-parts/national-orgs.vue';
import Love      from './page-parts/love-sky-farm.vue';
import Video     from './page-parts/video.vue';
import NkdAge    from './page-parts/naked-age.vue';

export default {
    components: {Events, Visit, WhatsNude, National, Love, Video, NkdAge},
    data: () => {
        return {
            name: 'HelloWorld',
            bheight: 150,
            facts: [
                "Sky Farm is a membership community. Day passes are not available.",
                "Unlike Gunnison, at Sky Farm there are no long walks to paradise!",
                "Enjoy our pristine pool, relaxing hot tub and soothing sauna.",
                "Get involved! Our calendar of events has something for everyone!<ul><li>Volleyball, Tennis, Nude Yoga, Pétanque, Themed Dinners, Pool Parties & More!</li></ul>",
                "<b>Facilities Include:</b>  Heated Pool, Hot Tub, Sauna, Kids Playground, Tent Camping, <br>Free WIFI, Lodge rooms, Clubhouse, Large Sun Lawns, Nature Trails and so much more.",
                "Relax as you enjoy cold beverages and make new friends.",
                "Sky Farm is open 24/7 May to October.",
                "BBQ lunch is available for purchase most weekends during the season."
            ],

        }
    },
    methods: {
        callSocial(i) {
            this.$gtag.event('linkto', { event_label: this.socials[i].title });
            window.open(this.socials[i].url, '_blank')
        },
    },
    mounted() {
        // this.$gtag.pageview({ page_path: this.$route.path, page_title: 'Site Home'})
        if ( this.$vuetify.breakpoint.mdAndUp ) this.bheight = 350;
    },
}
</script>
